export const sum = (accumulator: number, current: number) => accumulator + current

export const truthyPredicate = <T>(x: T | false | undefined | null | '' | 0): x is T => !!x // will not work for NaN
